module.exports = __webpack_public_path__ + "media/images/lightbox/thumb-v-y-1-3191cc6fd55e5de9981e0208d94eac1e.jpg";